import { useTranslation } from 'react-i18next';
import { useOrg } from '@/contexts/OrgContext';
import { SettingsSection } from '@/components/settings/SettingsSection';

export function EInvoicingSection() {
  const { t } = useTranslation();
  const { org } = useOrg();

  if (org?.countryTemplate !== 'eg' && org?.countryTemplate !== 'sa') return null;

  return (
    <SettingsSection id="settings-e-invoicing" title={t('settings.eInvoicing')}>
      <ul className="list-inside list-disc text-sm text-[var(--fv-text-muted)]">
        <li>{t('settings.eInvoiceUuid')}</li>
        <li>{t('settings.eInvoiceQr')}</li>
        <li>{t('settings.eInvoiceExport')}</li>
        <li>{t('settings.eInvoiceLiveApi')}</li>
      </ul>
    </SettingsSection>
  );
}
